export let baseJSON = [
  {
    title: '服务简介',
    content:
      '自2009年以来，园测信科一直致力于扶持公安项目的发展，为社会治安提供有力保障。项目涵盖了多个领域，包括信息化建设、重点安保区域的安保力量升级、交警静态设施动态管理、一体化孪生系统，信号控制系统、特殊场景实战指挥系统等。' +
      '在技术支持方面，我司为公安部门提供7x24小时的技术支持服务，确保公安系统的正常运行。同时，我们还积极参与公安部门的科技创新项目，推动公安事业的现代化发展。' +
      '园测信科一直关注公安事业的发展，致力于为公安部门提供全方位的支持。我们将继续努力，为构建和谐安全的社会环境贡献自己的力量。',
    imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/serviceimg.jpg'),
  },

  {
    title: '痛点分析',
    moduleList: [
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/tdbase.png'),
        chtitle: '痛点分析1',
        content:
          '通过对数据进行定标、编目、清洗、优化，可以构建全方位获取、全网络汇聚、全流程处理的全息基础数据库。根据制定的不同来源数据的优先级，进行专题数据抽取与融合，形成全维度整合、准确权威的专题数据库。',
      },
    ],
  },

  {
    title: '核心价值',
    moduleList: [
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '核心价值1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
    ],
  },

  {
    title: '特色应用',
    moduleList: [
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
      {
        imgUrl: require('@/assets/img/childrenpage/smartPublicSecurity/coreicon1.png'),
        chtitle: '特色应用1',
        content:
          '依托园测信息多年的数据沉淀、强大的地图制作能力，凭借自主研发的Mapmost技术路线，实现专网环境下多端支持的地图产品，服务于GIS向政府部门与公用企业。',
      },
    ],
  },
];
